// extracted by mini-css-extract-plugin
module.exports = {"container":"Stocks_container__3jQ_r","overflowContainer":"Stocks_overflowContainer__2EzhO","stats":"Stocks_stats__ufHQi"};